import { render } from "./edit_order.vue?vue&type=template&id=154ad5ca"
import script from "./edit_order.vue?vue&type=script&lang=js"
export * from "./edit_order.vue?vue&type=script&lang=js"

import "./edit_order.vue?vue&type=style&index=0&id=154ad5ca&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__